/**
 * Animation.js
 * サイト全体のアニメーション制御 (Hero, Scroll, Fade)
 */

// 1. スクロールアニメーション (Intersection Observer) - ★最優先で実行
function initScrollObserver() {
  const fadeObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in-view');
        fadeObserver.unobserve(entry.target); // 一度表示したら監視終了
      }
    });
  }, { 
    rootMargin: "0px 0px -10% 0px", // 画面の下10%まで来たら発火
    threshold: 0 
  });

  // 監視対象のクラスを網羅的に指定
  const fadeElements = document.querySelectorAll(
    '.u-fade-up, .u-fade-in, .u-clip-reveal-left, .u-clip-reveal-up, .u-blur-fade, .u-img-zoom-out, .js-stagger-group'
  );
  
  fadeElements.forEach(el => fadeObserver.observe(el));

  // --- Stagger Group Logic (順番に表示) ---
  const staggerObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // 全てのアニメーション系子要素を取得
        const children = entry.target.querySelectorAll(
          '.u-fade-up, .u-fade-in, .u-clip-reveal-left, .u-clip-reveal-up, .u-blur-fade'
        );
        children.forEach(child => child.classList.add('is-in-view'));
        staggerObserver.unobserve(entry.target);
      }
    });
  }, { rootMargin: "0px 0px -10% 0px" });

  const staggerGroups = document.querySelectorAll('.js-stagger-group');
  staggerGroups.forEach(group => staggerObserver.observe(group));
}

// 2. スムーススクロール
function initSmoothScroll() {
  const links = document.querySelectorAll('a[href*="#"]');
  const headerHeight = 80;

  links.forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (!href || href === '#') return;

      const targetUrl = href.split('#')[0];
      const currentUrl = window.location.href.split('#')[0];

      if (targetUrl && targetUrl !== currentUrl && !href.startsWith('#')) {
        return;
      }

      const targetId = href.split('#')[1];
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        e.preventDefault();
        const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
        
        window.scrollTo({
          top: targetPosition - headerHeight,
          behavior: 'smooth'
        });
        
        history.pushState(null, null, '#' + targetId);
      }
    });
  });
}

// 3. 粒子アニメーション (非同期読み込み) - ★awaitで止めないように分離
async function initParticles() {
  // --- TOP Hero ---
  const animContainer = document.getElementById('tsparticles');
  if (animContainer && window.tsParticles) {
      const count = parseInt(animContainer.dataset.count) || 80;
      const speed = parseFloat(animContainer.dataset.speed) || 2;
      const distance = parseInt(animContainer.dataset.distance) || 150;
      let colors = ["#1658a0", "#ea580c", "#cbd5e1"];
      try {
          if (animContainer.dataset.colors) {
              colors = JSON.parse(animContainer.dataset.colors);
          }
      } catch (e) {
          console.error('Color parse error', e);
      }

      await tsParticles.load("tsparticles", {
          fullScreen: { enable: false },
          background: { color: "transparent" },
          particles: {
              number: { value: count, density: { enable: true, area: 800 } },
              color: { value: colors },
              shape: { type: "circle" },
              opacity: { value: 0.6, random: true },
              size: { value: { min: 2, max: 6 } },
              links: {
                  enable: true,
                  distance: distance,
                  color: "#94a3b8",
                  opacity: 0.4,
                  width: 1
              },
              move: {
                  enable: true,
                  speed: speed,
                  direction: "none",
                  random: false,
                  straight: false,
                  outModes: { default: "bounce" },
              }
          },
          interactivity: {
              detectsOn: "canvas",
              events: {
                  onHover: { enable: true, mode: "grab" },
                  onClick: { enable: true, mode: "push" }
              },
              modes: {
                  grab: { distance: 140, links: { opacity: 1 } },
                  push: { quantity: 4 }
              }
          },
          detectRetina: true
      });
  }

  // --- Sub Page Hero ---
  const subAnimContainer = document.getElementById('tsparticles-sub');
  if (subAnimContainer && window.tsParticles) {
      await tsParticles.load("tsparticles-sub", {
          fullScreen: { enable: false },
          background: { color: "transparent" },
          particles: {
              number: { value: 30, density: { enable: true, area: 800 } },
              color: { value: ["#1658a0", "#ea580c", "#cbd5e1"] },
              shape: { type: "circle" },
              opacity: { value: 0.5, random: true },
              size: { value: { min: 10, max: 20 } },
              links: { enable: false },
              move: {
                  enable: true,
                  speed: 0.6,
                  direction: "none",
                  random: true,
                  straight: false,
                  outModes: { default: "bounce" },
              }
          },
          interactivity: {
              detectsOn: "canvas",
              events: {
                  onHover: { enable: true, mode: "bubble" },
                  onClick: { enable: false }
              },
              modes: {
                  bubble: { distance: 200, size: 6, duration: 2, opacity: 0.8 }
              }
          },
          detectRetina: true
      });
  }
}

// === メイン実行関数 ===
export default function initAnimation() {
  // 1. スクロール監視とスムーススクロールを即座に実行 (待たない)
  initScrollObserver();
  initSmoothScroll();

  // 2. 粒子アニメーションは裏で実行開始 (待たない)
  initParticles(); 
}